// 品牌数字门店
export default [
    {
        path: '/store',
        redirect: '/store/shop',
    },
    {
        path: '/store/shop',
        name: 'digital-shop-shop',
        component: () => import(/* webpackChunkName: "brand-store" */ '@/views/brand-store/shop/Index.vue'),
        meta: {title: '门店管理'},
    },
    {
        path: '/store/resource',
        name: 'digital-shop-resource',
        component: () => import(/* webpackChunkName: "brand-store" */ '@/views/brand-store/resource/Index.vue'),
        meta: {title: '内容管理'},
    },
];
